import { render, staticRenderFns } from "./SoldWinesScreenMobile.vue?vue&type=template&id=97c3144c"
import script from "./SoldWinesScreenMobile.vue?vue&type=script&lang=js"
export * from "./SoldWinesScreenMobile.vue?vue&type=script&lang=js"
import style0 from "./SoldWinesScreenMobile.vue?vue&type=style&index=0&id=97c3144c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports